import React, { useState } from "react";
import { FaEdit, FaUpload } from "react-icons/fa";
import { useGetGroupingList, useGetInsertGrouping } from "../../hooks/useCrm";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import Button from "../Button/Button";
import { UpdateGroupingItemModal } from "../Dialog/UpdateGroupingItemModal";
import { UpdateGroupingItemStatusModal } from "../Dialog/UpdateGroupingItemStatusModal";
import { InputField1 } from "../InputField1/InputField1";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import { Table } from "../Table/Table";
const initvalue = {
  TitleGroping: null,
  ContentGroping: null,
  LanguageGroping: null,
};
const Grouping = () => {
  const [form, setForm] = useState(initvalue);
  const [Search, setSearch] = useState("");
  const [item, setItem] = useState(null);
  const [show, setShow] = useState({
    update: false,
    updateStatus: false,
  });
  const { data: groupingList } = useGetGroupingList();
  const { mutateAsync: insertGrouping } = useGetInsertGrouping();

  const GroupingListHeader = [
    "ردیف",
    "عنوان",
    "محتوا",
    "زبان",
    "وضعیت",
    "عملیات",
  ];
  const GroupingOption = groupingList?.data?.groping[0]?.map((res) => {
    return {
      value: res,
      label: res,
    };
  });
  const handleInsert = async (data) => {
    await insertGrouping(data).then(() => setForm(initvalue));
  };

  const items = groupingList?.data?.groping_new_user_crms

    ?.filter((item) => {
      if (Search === "") {
        return item;
      } else if (item.SubjectTicket.includes(Search)) {
        return item;
      }
    })
    ?.map((item, index) => {
      return (
        <tr key={index}>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {index + 1}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.TitleGroping}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              <span className={`text-muted fw-bold text-muted d-block fs-7`}>
                {item?.ContentGroping}
              </span>
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.LanguageGroping === "fa"
                ? "فارسی"
                : item?.LanguageGroping === "en"
                ? "انگلیسی"
                : "عربی"}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              <span className={`text-muted fw-bold text-muted d-block fs-7`}>
                {item?.StatusGroping === "Active" ? "فعال" : "غیر فعال"}
              </span>
            </span>
          </td>

          <td>
            <span
              className={`text-muted fw-bold text-muted d-block fs-7 d-flex`}
            >
              <Button
                small="fit-content"
                color="#fff"
                bgColor="#009ef7"
                className="mx-2"
                onclick={() => {
                  setItem(item);
                  setShow({ ...show, update: true });
                }}
              >
                <FaEdit />
              </Button>
              <Button
                small="fit-content"
                color="#fff"
                bgColor="#f1416c"
                onclick={() => {
                  setItem(item?.IdGropingNewUserCrm);
                  setShow({ ...show, updateStatus: true });
                }}
              >
                <FaUpload />
              </Button>
            </span>
          </td>
        </tr>
      );
    });
  return (
    <>
      <BreadCrumb
        margin="mt-3"
        num1="واحد CRM"
        num2="دسته بندی CRM"
        href1="/dashboard/crm"
      />
      <div className="shadow-lg shadow-black/50 rounded-lg mx-3">
        <div className="row bg-[#EEF3F7] p-2 px-3 text-[14px] font-bold">
          ایجاد دسته بندی
        </div>
        <div className="bg-white row p-1 pb-3 rounded-b-lg">
          <div className="col-lg-4 col-12">
            <SimpleSelect1
              res={GroupingOption}
              label="موضوع"
              onChange={(e) => setForm({ ...form, TitleGroping: e.value })}
              placeholder={
                form.TitleGroping ? form.TitleGroping : "انتخاب کنید..."
              }
            />
          </div>
          <div className="col-lg-4 col-12">
            <InputField1
              placeholder="محتوا"
              label="محتوا"
              onChange={(e) =>
                setForm({ ...form, ContentGroping: e.target.value })
              }
              value={form?.ContentGroping ? form?.ContentGroping : ""}
            />
          </div>
          <div className="col-lg-4 col-12">
            <SimpleSelect1
              res={[
                { value: "fa", label: "فارسی" },
                { value: "en", label: "انگلیسی" },
              ]}
              label="زبان"
              onChange={(e) => setForm({ ...form, LanguageGroping: e.value })}
              placeholder={
                form.LanguageGroping ? form.LanguageGroping : "انتخاب کنید..."
              }
            />
          </div>
          <div className="col-12 flex justify-end">
            <Button
              bgColor="#009ef7"
              small="fit-content"
              color="#fff"
              onclick={() => handleInsert(form)}
            >
              ثبت
            </Button>
          </div>
        </div>
      </div>
      <Table
        className="mt-3"
        setSearch={setSearch}
        headerTitle={GroupingListHeader}
        items={items}
        title={`دسته بندی ها`}
      />
      <UpdateGroupingItemModal
        show={show.update}
        handleClose={() => setShow({ ...show, update: false })}
        item={item}
        GroupingOption={GroupingOption}
      />
      <UpdateGroupingItemStatusModal
        show={show.updateStatus}
        handleClose={() => setShow({ ...show, updateStatus: false })}
        id={item}
      />
    </>
  );
};

export default Grouping;
